export const STAKING_DURATION_1_DAY = '1D';
export const STAKING_DURATION_FIXED = 'Fixed';

export const STAKING_LIMIT = 350;

export const STAKE_ALL = 'Stake All';
export const UNSTAKE_ALL = 'Unstake All';
